import { forwardRef } from "react"
import { ReactionSelector, ReactionSelectorProps } from "stream-chat-react"
import { useReactions } from "source/shared/hooks/useReactions"

function CustomReactionSelectorInner(
  props: ReactionSelectorProps,
  ref: React.ForwardedRef<HTMLDivElement | null>,
) {
  const reactionOptions = useReactions()

  return (
    <ReactionSelector {...props} ref={ref} reactionOptions={reactionOptions} />
  )
}

export const CustomReactionSelector = forwardRef(CustomReactionSelectorInner)
